/**
 * Shared shopper identity for cart landing caches (snapshot + view-model).
 * Kept in a tiny module to avoid circular imports between cache helpers.
 * @return {string} Shopper-scoped cache key, or empty when identity is incomplete.
 */
export const buildCartLandingShopperKey = ({
  isAuth = false,
  customerId = "",
  anonymousId = "",
} = {}) => {
  if (isAuth) return customerId ? `auth:${customerId}` : ""
  return anonymousId ? `guest:${anonymousId}` : ""
}
